import { useEffect, useState } from 'react';
import { officeReady } from '@/services/office/officeReady';
import { getOfficeUserProfile, type OfficeUserProfile } from '@/services/office/userProfile';

/**
 * Reads the signed-in user's Office profile (display name + address) once Office
 * is ready. Null until resolved, and stays null outside a mailbox host.
 */
export function useUserProfile(): OfficeUserProfile | null {
  const [profile, setProfile] = useState<OfficeUserProfile | null>(null);

  useEffect(() => {
    let cancelled = false;
    void officeReady().then(() => {
      const p = getOfficeUserProfile();
      if (!cancelled && p) setProfile(p);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return profile;
}
